export default {"src":"/_next/static/media/icon_store_v2_timer.6467ac88.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};